import React, { useCallback, useMemo, useState } from 'react';
import { selectCalendar, selectFilter } from '../../../../store/selectors';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store/store';
import UDButton from 'ud-ui/components/button';
import { UDSelect } from 'ud-form/components/select/component';
import UDText from 'ud-ui/components/text';
import _ from 'lodash';
import { components } from './styles';
import { setChampionshipFilter } from '../../../../store';
import Modal from 'ud-ui/components/modal';

function useFilterModal() {
  const dispatch = useDispatch<AppDispatch>();
  // const { close, open, Modal } = useModal();
  const calendar = useSelector(selectCalendar);
  const filter = useSelector(selectFilter);
  const championships = useMemo(() => {
    const matches = Object.values(calendar)
      .flat()
      .map((day) => day.matches)
      .flat();
    return _(matches).map('championship.name').uniq().value();
  }, [calendar]);
  const [isOpen, setIsOpen] = useState(false);

  const [selectedChampionship, setSelectedChampionship] = useState(filter.championship);

  const options = useMemo(() => {
    return [{ value: 'all', label: 'Все' }, ...championships.map((name) => ({ value: name, label: name }))];
  }, [championships]);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onOpen = useCallback(() => {
    open();
  }, [open]);

  const onClickSubmit = useCallback(() => {
    dispatch(setChampionshipFilter(selectedChampionship));
    close();
  }, [close, dispatch, selectedChampionship]);

  const component = useMemo(() => {
    return (
      <Modal show={isOpen} onClose={close}>
        <Modal.Body>
          <UDText className="mb-7.5" type={'title-3'}>
            Фильтровать по лигам
          </UDText>
          <div style={{ maxWidth: 370 }}>
            <UDSelect
              onChange={(newValue) => setSelectedChampionship(newValue?.value ?? 'all')}
              options={options}
              value={options.find(({ value }) => value === selectedChampionship)}
              components={components}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <UDButton stretch variant={'primary'} onClick={onClickSubmit}>
            Применить
          </UDButton>
        </Modal.Footer>
      </Modal>
    );
  }, [close, isOpen, onClickSubmit, options, selectedChampionship]);

  return { close, open: onOpen, modal: component };
}

export default useFilterModal;
